// extracted by mini-css-extract-plugin
module.exports = {"tbLoadingGlobal":"Loading_tbLoadingGlobal__NWzWR","tbLoadingButton":"Loading_tbLoadingButton__FUY2f"};